import React from "react";


const AiInsightsContentSkeleton = () => {
  const lines = Array.from({ length: 16 }, (_, i) => i);

  const getWidth = (index) => {
    const mod = index % 4;
    if (mod === 0) return "60%";
    if (mod === 1) return "75%";
    if (mod === 2) return "90%";
    return "100%";
  };

  return (
    <div>
      <div>
        {lines.map((line, index) => (
          <div
            key={index}
            style={{
              height: "12px",
              backgroundColor: "#CCCCCC",
              borderRadius: "6px",
              marginBottom: "12px",
              width: getWidth(index),
              animation: "pulse 1.5s ease-in-out infinite"
            }}
          />
        ))}
      </div>

      <style>
        {`
          @keyframes pulse {
            0%, 100% {
              opacity: 0.7;
            }
            50% {
              opacity: 0.4;
            }
          }

          div[style*="animation: pulse"] {
            animation-timing-function: ease-in-out;
          }
        `}
      </style>
    </div>
  );
};


export default AiInsightsContentSkeleton;
